/**
 * Solandia sun/spark mark — a simple SVG sun. Used in the wordmark and the
 * sign-in screen. Indigo orb + amber rays = "sunshine after the storm".
 */
export function SunMark({ size = 28 }: { size?: number }) {
  const r = size;
  return (
    <svg
      width={r}
      height={r}
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      {/* rays */}
      <g stroke="#F5A623" strokeWidth="2.4" strokeLinecap="round">
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="16" y1="26" x2="16" y2="30" />
        <line x1="2" y1="16" x2="6" y2="16" />
        <line x1="26" y1="16" x2="30" y2="16" />
        <line x1="6.2" y1="6.2" x2="9" y2="9" />
        <line x1="23" y1="23" x2="25.8" y2="25.8" />
        <line x1="25.8" y1="6.2" x2="23" y2="9" />
        <line x1="9" y1="23" x2="6.2" y2="25.8" />
      </g>
      {/* orb */}
      <circle cx="16" cy="16" r="6.5" fill="#4F6DF5" />
      <circle cx="16" cy="16" r="6.5" fill="#4F6DF5" />
    </svg>
  );
}

export function Wordmark({ size = 28 }: { size?: number }) {
  return (
    <span className="wordmark">
      <SunMark size={size} />
      <span>Solandio</span>
    </span>
  );
}
